import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mandatory',
  templateUrl: './mandatory.component.html',
  styleUrls: ['./mandatory.component.scss']
})
export class MandatoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
